import { render, staticRenderFns } from "./ManageLessonModal.vue?vue&type=template&id=ce0dec10&"
import script from "./ManageLessonModal.vue?vue&type=script&lang=ts&"
export * from "./ManageLessonModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports